<template>
  <div class="upload-json-div">
    <div class="upload-json">
      <h2>
        Upload the JS
        <img class="pokeball" height="25" src="@/assets/pokeball.png" />N!
      </h2>
      <a>
        <img
          src="https://fontmeme.com/permalink/190801/3b8b9d2a748e098ed401c1e04e711fdd.png"
          alt="pokemon-font"
          border="0"
        />
      </a>
      <div class="upload" @click="onClick">
        <label for="genomic-paper-upload" class="genomic-paper-upload">
          <img height="50" src="@/assets/gotta-catch.png" />
        </label>
        <input
          id="genomic-paper-upload"
          type="file"
          accept="application/json"
          @change="readFiles($event, 'genomicPaper')"
          multiple
        />
      </div>
      <a>
        <img
          src="https://fontmeme.com/permalink/190801/30f900f7f588a0d5936519be41b8945a.png"
          alt="pokemon-font"
          border="0"
        />
      </a>
      <div class="upload" @click="onClick">
        <label for="microbiome-paper-upload" class="microbiome-paper-upload">
          <img height="50" src="@/assets/gotta-catch.png" />
        </label>
        <input
          id="microbiome-paper-upload"
          type="file"
          accept="application/json"
          @change="readFiles($event, 'microbiomePaper')"
          multiple
        />
      </div>
      <a>
        <img
          src="https://fontmeme.com/permalink/190801/64daff15fce2146d97915ed4e1b918b5.png"
          alt="pokemon-font"
          border="0"
        />
      </a>
      <div class="upload" @click="onClick">
        <label for="microbiome-description-upload" class="microbiome-description-upload">
          <img height="50" src="@/assets/gotta-catch.png" />
        </label>
        <input
          id="microbiome-description-upload"
          type="file"
          accept="application/json"
          @change="readFiles($event, 'microbiomeDescription')"
          multiple
        />
      </div>
    </div>
    <div class="response">
      <div class="error-message" v-for="(error, index) in errors" :key="index">
        <img class="error-image" src="@/assets/sad-pika.gif" />
        <div style="width: 100%">
          <div class="error-filename">{{error.filename}}</div>
          <div>{{error.error}}</div>
        </div>
      </div>
      <div v-if="fileType && !errors.length">
        <img class="success-img" src="@/assets/looks-good-pika.gif" />
        <div class="success-message">JSON looks good to me!</div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { postGenomicPaper } from '@/javascript/genomic';
import {
  postMicrobiomeDescription,
  postMicrobiomePaper,
} from '@/javascript/microbiome';

export default {
  data() {
    return {
      errors: [],
      fileType: null,
    };
  },
  methods: {
    readFiles(event, fileType) {
      this.errors = [];
      this.fileType = fileType;
      _.forEach(event.target.files, this.readFile);
      // Reset input value, so you can upload the same file twice (e.g. making edits and reuploading)
      event.target.value = '';
    },
    async readFile(file) {
      const text = await file.text();
      let error;
      try {
        const json = JSON.parse(text);
        error = await this.postFile(json);
      } catch (err) {
        error = err.message;
      }

      if (error) this.errors.push({ filename: file.name, error });
    },
    async postFile(file) {
      switch (this.fileType) {
        case 'genomicPaper':
          return postGenomicPaper(file);
        case 'microbiomePaper':
          return postMicrobiomePaper(file);
        case 'microbiomeDescription':
          return postMicrobiomeDescription(file);
        default:
          return "Wuh oh, can't determine file type.";
      }
    },
    onClick() {
      this.error = '';
      this.success = '';
      // const sound = new Audio(require("../assets/pikachu.mp3"));
      // sound.play();
    },
  },
};
</script>

<style>
.upload-json-div {
  padding-top: 5vh;
  margin-left: 5vw;
}

.upload-json {
  display: flex;
  flex-direction: column;
  width: 80vh;
  height: 80vh;
  background: #fffffff0;
  border-radius: 50%;
  padding: 30px;
  border: 7px solid #f62d14;
}

.upload {
  margin-bottom: 3vh;
}

input[type='file'] {
  display: none;
}

.genomic-paper-upload,
.microbiome-paper-upload,
.microbiome-description-upload {
  cursor: pointer;
}

label img {
  border: 3px solid black;
  border-radius: 5px;
  padding: 5px 10px;
  background-color: #ffe664;
}

label img:hover {
  background-color: red;
  cursor: pointer;
}

.upload-json input {
  margin: 0 auto;
}

.pokeball {
  vertical-align: sub;
}

.response {
  display: flex;
  flex-direction: column;
  overflow: scroll;
  position: absolute;
  max-height: 60vh;
  width: 70vh;
  right: 10vh;
  bottom: 1vh;
  border-radius: 5px;
  background: #ffffff;
}

.error-image {
  height: 70px;
  width: 80px;
}

.error-message {
  display: flex;
  z-index: 10;
  color: red;
  font-weight: bold;
  font-size: medium;
  text-align: center;
  padding: 10px;
  border-bottom: 1px dashed blue;
}

.error-filename {
  color: #333;
}

.success-img {
  position: relative;
  right: 5vh;
  width: 120%;
  height: auto;
}

.success-message {
  position: absolute;
  top: 15vh;
  margin: 4vh;
  color: lightgreen;
  font-weight: bold;
  font-size: medium;
  text-align: center;
}
</style>
